export default __webpack_public_path__ + "static/media/metamask_steps_2.d65a753b.png";